//import liraries
import React, { Component, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  Image,
} from "react-native";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLocation } from "react-router-dom";
import styles from "./QuickLinks_Styles";
const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

// create a component
const QuickLinks = (props) => {
    const location = useLocation();
    const currentPath = location.pathname.split("/")[2];
const onNavigate = () => {
  console.log("nnnnn",props)
  if(props?.activeScreen == "Pool Account Details"){
    
    if(props?.activeScreen == "Pool Account Details") {
      
      props.setIsManual("Change Manual")
    }
    props.setScreen("Pool Account Details")
    
    props.setIsManual("Change Manual")
  }
  else{
    RootNavigation.navigate("Profile",{screen:"Pool Account Details", selectedLayout:"Change Manual"} )
    global.activeScreen = "Profile";
  }
}

    return (
        <View>
          <View
            style={{
              width: "100%",
              height: 0,
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#eeeeee",
              marginTop: isSmallDevice ? null : 40,
            }}
          />
          <View
              style={{
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingLeft:isSmallDevice ? 10 : isTabView ? 20 : 90,
                display : isSmallDevice ? "flex" : "none",
                flexDirection: "row",
                marginTop:10

              }}
            >
              <Image
                source={require("../../assets/images/Quick_Links_Icon.png")}
                style={{
                  height: isSmallDevice ? 14 : 26,
                  width: isSmallDevice ? 14 : 26,
                  resizeMode: "center",
                  alignSelf: "flex-start",
                }}
              />
              <Text
                style={{
                  fontFamily: "Inter",
                  fontSize: isSmallDevice ? 7 :  11,
                  fontWeight: "normal",
                  fontStyle: "normal",
                  lineHeight: 14,
                  letterSpacing: 0.33,
                  textAlign: "left",
                  color: "#30424e",
                }}
              >
                {"Quick Links"}
              </Text>
            </View>
          <View style={{ flexDirection: "row", paddingTop: isSmallDevice ? 0 :  20, marginLeft : isSmallDevice ? 10 : null }}>
            <View
              style={{
                alignItems: "center",
                justifyContent: "center",
                paddingLeft:isSmallDevice|| isTabView ?20 : 90,
                display:isSmallDevice ? "none" : "flex"
              }}
            >
              <Image
                source={require("../../assets/images/Quick_Links_Icon.png")}
                style={{
                  height: isSmallDevice ? 14 : 26,
                  width: isSmallDevice ? 14 : 26,
                  resizeMode: "center",
                  alignSelf: "center",
                }}
              />
              <Text
                style={{
                  fontFamily: "Inter",
                  fontSize: isSmallDevice ? 7 : 11,
                  fontWeight: "normal",
                  fontStyle: "normal",
                  lineHeight: 14,
                  letterSpacing: 0.33,
                  textAlign: "left",
                  color: "#30424e",
                }}
              >
                {"Quick Links"}
              </Text>
            </View>
            <View style={{ marginLeft:isSmallDevice ? 5 : isTabView ? 20 : 91 }}>
            <TouchableOpacity onPress={  ()=>{
              RootNavigation.navigate("Recharge")
              global.activeScreen = "Recharge";
              }}>
              <Text style={styles.quickLinksTextStyle}>
                {"Recharge Pool Account"}
              </Text>
            </TouchableOpacity>
              <TouchableOpacity onPress={()=>{
              RootNavigation.navigate("Statement")
              global.activeScreen = "Statement";
              }}>
              <Text style={styles.quickLinksTextStyle}>
              {"Pool Account Statement"}
              </Text>
            </TouchableOpacity>
            </View>
            <View style={{ marginLeft: isSmallDevice ? 20 : 91,justifyContent : isSmallDevice ?  "flex-end" : null }}>
            <TouchableOpacity 
            onPress={() => RootNavigation.navigate("Profile/PoolAccount/ChangeManual")}>
              <Text style={styles.quickLinksTextStyle}>
                {"Change Pool Account Type"}
              </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => {
                 RootNavigation.navigate("Help")
                 global.activeScreen = "Help";
                }}
                  >
              <Text style={styles.quickLinksTextStyle}>
                {"FAQ"}
              </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
    );
};


//make this component available to the app
export default QuickLinks;
